<template>
  <b-overlay :show="loading" class="row bg-white ">
    <div class="col-12" v-if="showNoImageAlert">
      <b-alert
        variant="warning"
        class="col-12 pt-5 pb-5 pl-3"
        show
      >
        <feather-icon
          icon="AlertCircleIcon"
          class="mr-2"
        />
        Lote no cuenta con imágenes
      </b-alert>
    </div>
    <div class="col-4">
      <UploadFile
        permission="ED188"
        text="Seleccionar imagen"
        accept=".jpg,.png"
        :max-size-in-mb="30"
        v-model="additionalImage"
        :upload-to="urlFile"
        button-class="btn-block"
        container-class="w-100"
        @input="addAdditionalFile()"
      />
    </div>
    <div class="col-12 mt-3" v-if="newImages.length">
      <h5>Imágenes nuevas</h5>
      <div class="mt-3" v-if="newImages.length">
        <b-table-simple hover small>
          <b-thead>
            <b-tr>
              <b-th scope="col">Nombre archivo</b-th>
              <b-th scope="col" class="text-center">-</b-th>
            </b-tr>
          </b-thead>
          <b-tbody v-if="newImages.length">
            <b-tr v-for="file in newImages" :key="file.id">
              <b-td>
                <div class="d-flex align-items-center">
                  <vs-icon icon="file_present" size="medium" class="mr-1"/>
                  {{file.name}}
                </div>
              </b-td>
              <b-td class="text-center">
                <b-button
                  v-has-permission="'ED189'"
                  size="sm"
                  variant="outline-danger"
                  @click="removeNewFile(file.id)"
                >
                  remover
                </b-button>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
      <div class="text-right">
        <b-button
          v-has-permission="'ED190'"
          variant="outline-secondary"
          class="mr-2"
          @click="saveNewImages()"
        >
          Agregar imágenes
        </b-button>
      </div>
    </div>
    <div class="col-12 mt-3" v-if="batchImages.length">
      <b-table-simple hover small>
        <b-thead>
          <b-tr>
            <b-th scope="col">Nombre archivo</b-th>
            <b-th scope="col">Principal</b-th>
            <b-th scope="col">Preview</b-th>
            <b-th scope="col" class="text-center">acciones</b-th>
          </b-tr>
        </b-thead>
        <b-tbody v-if="batchImages.length">
          <b-tr v-for="file in batchImages" :key="file.imagenId">
            <b-td>
              <div v-tooltip="'Principal'" class="d-flex align-items-center">
                {{file.nombre}}
              </div>
            </b-td>
            <b-td class="text-center">
              <vs-checkbox
                v-on:change="markPrincipalImage(file)"
                class="ml-5 pl-5"
                v-model="file.principal"
              />
            </b-td>
            <b-td class="text-center">
              <img
                :src="file.urlImagen"
                alt="image"
                class="cursor-pointer img-batch"
              />
            </b-td>
            <b-td class="text-center">
              <b-button
                size="sm"
                variant="outline-danger"
                @click="removeAdditionalFile(file.imagenId)"
              >
                remover
              </b-button>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>
    <div class="col-12 text-right">
      <b-button
        v-has-permission="'ED190'"
        variant="outline-secondary"
        class="mr-2"
        @click="saveImages()"
      >
        Guardar
      </b-button>
    </div>
  </b-overlay>
</template>
<script>
import { mapGetters } from 'vuex';

import {
  getBatch,
  updateBatchImages,
  addBatchImages,
  deleteBatchImages
} from '@/febos/servicios/api/aduanas/batches.api';
import { selectedBatch } from '@/febos/aduanas/batches/store/getters';
import UploadFile from '@/febos/global/_vue/componentes/UploadFile';

export default {
  components: {
    UploadFile
  },
  data() {
    return {
      loading: false,
      urlFile: `febos-io/temporal/${process.env.VUE_APP_AMBIENTE}/aduanas/lotes/`,
      error: {
        message: ''
      },
      additionalImage: {},
      batchImages: [],
      newImages: [],
      batchSelected: {},
      show: false,
    };
  },
  props: ['batch'],
  computed: {
    ...mapGetters('batches', {
      selectedBatch: selectedBatch.name
    }),
    showNoImageAlert() {
      return (!this.batchImages.length && !this.loading && !this.newImages.length);
    }
  },
  methods: {
    addAdditionalFile() {
      if (!Object.keys(this.additionalImage).length) {
        return;
      }

      if (this.additionalImage.failed) {
        // TODO: display error message.
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.newImages.push(this.additionalImage);
    },
    markPrincipalImage(file) {
      this.batchImages = this.batchImages.map((image, index) => {
        let img = image;
        if (image.imagenId === file.imagenId) {
          img = {
            ...image,
            principal: true,
            prioridad: 1
          };
          return img;
        }
        return {
          ...image,
          principal: false,
          prioridad: this.batchImages.length + (index + 1),
        };
      });
    },
    async removeAdditionalFile(fileId) {
      this.loading = true;
      const response = await deleteBatchImages({
        loteId: this.selectedBatch,
        imageId: fileId
      });
      this.loading = false;
      if (response.data.codigo === '10' || response.data.codigo === 10) {
        this.batchImages = this.batchImages
          .filter((file) => file.imagenId !== fileId);
        this.$emit('edit-images');
      } else {
        this.$vs.notify({
          title: 'Oops!',
          text: 'Ocurrió un error al intentar hacer la acción',
          color: 'danger',
          time: 4000,
          position: 'top-center'
        });
      }
    },
    removeNewFile(fileId) {
      this.newImages = this.newImages.filter((file) => file.id !== fileId);
    },
    async saveNewImages() {
      this.loading = true;
      const images = this.newImages.map((img, index) => ({
        urlTemporal: img.path,
        prioridad: this.batchImages.length + (index + 1),
        nombre: img.name
      }));
      const response = await addBatchImages({
        loteId: this.selectedBatch,
        images
      });
      this.loading = false;
      if (response.data.codigo === '10' || response.data.codigo === 10) {
        this.newImages = [];
        const imagenes = await getBatch({ loteId: this.selectedBatch });
        this.batchImages = imagenes.data.imagenes.map((img) => ({
          ...img,
          principal: img.prioridad === 1
        }));
        this.$emit('edit-images');
      } else {
        this.$vs.notify({
          title: 'Oops!',
          text: 'Ocurrió un error al intentar hacer la acción',
          color: 'danger',
          time: 4000,
          position: 'top-center'
        });
      }
    },
    async saveImages() {
      this.loading = true;
      const images = this.batchImages.map((img) => ({
        ...img,
        prioridad: img.principal ? 1 : img.prioridad,
        nombre: img.nombre
      }));
      const response = await updateBatchImages({
        loteId: this.selectedBatch,
        images
      });
      this.loading = false;
      if (response.data.codigo === '10' || response.data.codigo === 10) {
        const imagenes = await getBatch({ loteId: this.selectedBatch });
        this.batchImages = imagenes.data.imagenes.map((img) => ({
          ...img,
          principal: img.prioridad === 1
        }));
        this.$emit('close-modal');
      } else {
        this.$vs.notify({
          title: 'Oops!',
          text: 'Ocurrió un error al intentar hacer la acción',
          color: 'danger',
          time: 4000,
          position: 'top-center'
        });
      }
    }
  },
  async created() {
    this.loading = false;
    this.batchSelected = { ...this.batch };
    this.loading = true;
    const response = await getBatch({ loteId: this.selectedBatch });
    this.batchImages = response.data.imagenes.map((img) => ({
      ...img,
      principal: img.prioridad === 1
    }));
    this.loading = false;
  }
};
</script>
<style>
.container-description{
  max-height: 250px;
  overflow-y: scroll;
}
.img-batch {
  max-width: 150px;
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
}
</style>
